import React from 'react';

function FormInput({
  label,
  type = 'text',
  value,
  onChange,
  onBlur,
  name,
  error,
  touched,
  required = false,
  placeholder,
  autoComplete,
}) {
  return (
    <div>
      {label && (
        <label className="block text-gray-300 mb-2">
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}
      <input
        type={type}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        name={name}
        autoComplete={autoComplete}
        className={`w-full p-2 rounded bg-hdlcc-darkGray text-white border ${
          touched && error ? 'border-red-500' : 'border-hdlcc-gray'
        } focus:border-hdlcc-lightBlue focus:outline-none placeholder-gray-400
        [&:-webkit-autofill]:!bg-hdlcc-darkGray
        [&:-webkit-autofill]:!text-white
        [&:-webkit-autofill]:![-webkit-text-fill-color:white]
        [&:-webkit-autofill]:![transition-delay:0s]
        [&:-webkit-autofill]:![-webkit-box-shadow:0_0_0_50px_rgb(26,26,26)_inset]`}
        placeholder={placeholder}
        required={required}
      />
      {touched && error && <p className="text-red-500 text-sm mt-1">{error}</p>}
    </div>
  );
}

export default FormInput;
